import { Dispatch, SetStateAction } from "react";
import { AddWalletBalanceMonitorFields } from "..";
import { Box } from "src/components/MuiGenerals";
import WalletFieldSection from "./components/WalletFieldSection";
import ThresholdFieldSection from "./components/ThresholdFieldSection";

function Content({
  fields,
  setFields,
  isLowerThresholdInvalid,
  isUpperThresholdInvalid,
}: {
  fields: AddWalletBalanceMonitorFields;
  setFields: Dispatch<SetStateAction<AddWalletBalanceMonitorFields>>;
  isLowerThresholdInvalid: boolean;
  isUpperThresholdInvalid: boolean;
}) {
  return (
    <Box
      sx={{
        ".MuiInputLabel-shrink": {
          display: "none",
        },
      }}
    >
      <WalletFieldSection fields={fields} setFields={setFields} />

      <hr style={{ opacity: 0.5, marginTop: "30px", marginBottom: "24px" }} />

      <ThresholdFieldSection
        fields={fields}
        setFields={setFields}
        isLowerThresholdInvalid={isLowerThresholdInvalid}
        isUpperThresholdInvalid={isUpperThresholdInvalid}
      />
    </Box>
  );
}

export default Content;
